export default "__VITE_ASSET__BCKG1mVJ__"